export var calculatePagesToDisplay = function (currentPage, totalPage) {
    if (currentPage < 1 || totalPage < 1 || currentPage > totalPage) {
        return [];
    }
    if (totalPage === 1) {
        return [{ page: currentPage }];
    }
    if (totalPage === 2) {
        return currentPage === 1
            ? [{ page: currentPage }, { page: currentPage + 1, displayAfter: "us" }]
            : [{ page: currentPage - 1, displayAfter: "us" }, { page: currentPage }];
    }
    if (totalPage === 3) {
        if (currentPage === 1) {
            return [
                { page: currentPage },
                { page: currentPage + 1, displayAfter: "us" },
                { page: totalPage, displayAfter: "us" },
            ];
        }
        else if (currentPage === 2) {
            return [{ page: 1, displayAfter: "us" }, { page: currentPage }, { page: totalPage, displayAfter: "us" }];
        }
        else {
            return [
                { page: 1, displayAfter: "us" },
                { page: currentPage - 1, displayAfter: "us" },
                { page: currentPage },
            ];
        }
    }
    if (totalPage === 4) {
        if (currentPage === 1) {
            return [
                { page: currentPage },
                { page: currentPage + 1, displayAfter: "us" },
                { page: currentPage + 2, displayAfter: "sm" },
                { page: totalPage, displayAfter: "us" },
            ];
        }
        else if (currentPage === 2) {
            return [
                { page: currentPage - 1, displayAfter: "us" },
                { page: currentPage },
                { page: currentPage + 1, displayAfter: "sm" },
                { page: totalPage, displayAfter: "us" },
            ];
        }
        else if (currentPage === 3) {
            return [
                { page: currentPage - 2, displayAfter: "us" },
                { page: currentPage - 1, displayAfter: "sm" },
                { page: currentPage },
                { page: totalPage, displayAfter: "us" },
            ];
        }
        else {
            return [
                { page: currentPage - 3, displayAfter: "us" },
                { page: currentPage - 2, displayAfter: "sm" },
                { page: currentPage - 1, displayAfter: "us" },
                { page: currentPage },
            ];
        }
    }
    if (totalPage === 5) {
        if (currentPage === 1) {
            return [
                { page: currentPage },
                { page: currentPage + 1, displayAfter: "us" },
                { page: currentPage + 2, displayAfter: "sm" },
                { page: currentPage + 3, displayAfter: "sm" },
                { page: totalPage, displayAfter: "us" },
            ];
        }
        else if (currentPage === 2) {
            return [
                { page: currentPage - 1, displayAfter: "us" },
                { page: currentPage },
                { page: currentPage + 1, displayAfter: "sm" },
                { page: currentPage + 2, displayAfter: "sm" },
                { page: totalPage, displayAfter: "us" },
            ];
        }
        else if (currentPage === 3) {
            return [
                { page: currentPage - 2, displayAfter: "us" },
                { page: currentPage - 1, displayAfter: "sm" },
                { page: currentPage },
                { page: currentPage + 1, displayAfter: "sm" },
                { page: totalPage, displayAfter: "us" },
            ];
        }
        else if (currentPage === 4) {
            return [
                { page: currentPage - 3, displayAfter: "us" },
                { page: currentPage - 2, displayAfter: "sm" },
                { page: currentPage - 1, displayAfter: "sm" },
                { page: currentPage },
                { page: totalPage, displayAfter: "us" },
            ];
        }
        else {
            return [
                { page: currentPage - 4, displayAfter: "us" },
                { page: currentPage - 3, displayAfter: "sm" },
                { page: currentPage - 2, displayAfter: "us" },
                { page: currentPage - 1, displayAfter: "sm" },
                { page: currentPage },
            ];
        }
    }
    if (totalPage === 6) {
        if (currentPage === 1) {
            return [
                { page: currentPage },
                { page: currentPage + 1, displayAfter: "us" },
                { page: currentPage + 2, displayAfter: "sm" },
                { page: currentPage + 3, displayAfter: "lg" },
                { page: currentPage + 4, displayAfter: "sm" },
                { page: totalPage, displayAfter: "us" },
            ];
        }
        else if (currentPage === 2) {
            return [
                { page: currentPage - 1, displayAfter: "us" },
                { page: currentPage },
                { page: currentPage + 1, displayAfter: "sm" },
                { page: currentPage + 2, displayAfter: "lg" },
                { page: currentPage + 3, displayAfter: "sm" },
                { page: totalPage, displayAfter: "us" },
            ];
        }
        else if (currentPage === 3) {
            return [
                { page: currentPage - 2, displayAfter: "us" },
                { page: currentPage - 1, displayAfter: "sm" },
                { page: currentPage },
                { page: currentPage + 1, displayAfter: "lg" },
                { page: currentPage + 2, displayAfter: "sm" },
                { page: totalPage, displayAfter: "us" },
            ];
        }
        else if (currentPage === 4) {
            return [
                { page: currentPage - 3, displayAfter: "us" },
                { page: currentPage - 2, displayAfter: "lg" },
                { page: currentPage - 1, displayAfter: "sm" },
                { page: currentPage },
                { page: currentPage + 1, displayAfter: "sm" },
                { page: totalPage, displayAfter: "us" },
            ];
        }
        else if (currentPage === 5) {
            return [
                { page: currentPage - 4, displayAfter: "us" },
                { page: currentPage - 3, displayAfter: "sm" },
                { page: currentPage - 2, displayAfter: "lg" },
                { page: currentPage - 1, displayAfter: "sm" },
                { page: currentPage },
                { page: totalPage, displayAfter: "us" },
            ];
        }
        else {
            return [
                { page: currentPage - 5, displayAfter: "us" },
                { page: currentPage - 4, displayAfter: "sm" },
                { page: currentPage - 3, displayAfter: "lg" },
                { page: currentPage - 2, displayAfter: "sm" },
                { page: currentPage - 1, displayAfter: "us" },
                { page: currentPage },
            ];
        }
    }
    if (totalPage === 7) {
        if (currentPage === 1) {
            return [
                { page: currentPage },
                { page: currentPage + 1, displayAfter: "us" },
                { page: currentPage + 2, displayAfter: "sm" },
                { page: currentPage + 3, displayAfter: "lg" },
                { page: currentPage + 4, displayAfter: "lg" },
                { page: currentPage + 5, displayAfter: "sm" },
                { page: totalPage, displayAfter: "us" },
            ];
        }
        else if (currentPage === 2) {
            return [
                { page: currentPage - 1, displayAfter: "us" },
                { page: currentPage },
                { page: currentPage + 1, displayAfter: "sm" },
                { page: currentPage + 2, displayAfter: "lg" },
                { page: currentPage + 3, displayAfter: "lg" },
                { page: currentPage + 4, displayAfter: "sm" },
                { page: totalPage, displayAfter: "us" },
            ];
        }
        else if (currentPage === 3) {
            return [
                { page: currentPage - 2, displayAfter: "us" },
                { page: currentPage - 1, displayAfter: "sm" },
                { page: currentPage },
                { page: currentPage + 1, displayAfter: "lg" },
                { page: currentPage + 2, displayAfter: "lg" },
                { page: currentPage + 3, displayAfter: "sm" },
                { page: totalPage, displayAfter: "us" },
            ];
        }
        else if (currentPage === 4) {
            return [
                { page: currentPage - 3, displayAfter: "us" },
                { page: currentPage - 2, displayAfter: "lg" },
                { page: currentPage - 1, displayAfter: "sm" },
                { page: currentPage },
                { page: currentPage + 1, displayAfter: "sm" },
                { page: currentPage + 2, displayAfter: "lg" },
                { page: totalPage, displayAfter: "us" },
            ];
        }
        else if (currentPage === 5) {
            return [
                { page: currentPage - 4, displayAfter: "us" },
                { page: currentPage - 3, displayAfter: "lg" },
                { page: currentPage - 2, displayAfter: "lg" },
                { page: currentPage - 1, displayAfter: "sm" },
                { page: currentPage },
                { page: currentPage + 1, displayAfter: "sm" },
                { page: totalPage, displayAfter: "us" },
            ];
        }
        else if (currentPage === 6) {
            return [
                { page: currentPage - 5, displayAfter: "us" },
                { page: currentPage - 4, displayAfter: "sm" },
                { page: currentPage - 3, displayAfter: "lg" },
                { page: currentPage - 2, displayAfter: "lg" },
                { page: currentPage - 1, displayAfter: "sm" },
                { page: currentPage },
                { page: totalPage, displayAfter: "us" },
            ];
        }
        else {
            return [
                { page: currentPage - 6, displayAfter: "us" },
                { page: currentPage - 5, displayAfter: "sm" },
                { page: currentPage - 4, displayAfter: "lg" },
                { page: currentPage - 3, displayAfter: "lg" },
                { page: currentPage - 2, displayAfter: "sm" },
                { page: currentPage - 1, displayAfter: "us" },
                { page: currentPage },
            ];
        }
    }
    if (currentPage === 1) {
        return [
            { page: currentPage },
            { page: currentPage + 1, displayAfter: "us" },
            { page: currentPage + 2, displayAfter: "sm" },
            { ellipsis: true, displayAfter: "lg" },
            { page: totalPage - 2, displayAfter: "lg" },
            { page: totalPage - 1, displayAfter: "sm" },
            { page: totalPage, displayAfter: "us" },
        ];
    }
    if (currentPage === 2) {
        return [
            { page: 1, displayAfter: "us" },
            { page: currentPage },
            { page: currentPage + 1, displayAfter: "sm" },
            { ellipsis: true, displayAfter: "lg" },
            { page: totalPage - 2, displayAfter: "lg" },
            { page: totalPage - 1, displayAfter: "sm" },
            { page: totalPage, displayAfter: "us" },
        ];
    }
    if (currentPage === 3) {
        return [
            { page: 1, displayAfter: "us" },
            { page: currentPage - 1, displayAfter: "sm" },
            { page: currentPage },
            { page: currentPage + 1, displayAfter: "sm" },
            { ellipsis: true, displayAfter: "lg" },
            { page: totalPage - 1, displayAfter: "lg" },
            { page: totalPage, displayAfter: "us" },
        ];
    }
    if (currentPage === 4) {
        return [
            { page: 1, displayAfter: "us" },
            { page: currentPage - 2, displayAfter: "lg" },
            { page: currentPage - 1, displayAfter: "sm" },
            { page: currentPage },
            { page: currentPage + 1, displayAfter: "sm" },
            { ellipsis: true, displayAfter: "lg" },
            { page: totalPage, displayAfter: "us" },
        ];
    }
    if (currentPage === totalPage - 3) {
        return [
            { page: 1, displayAfter: "us" },
            { ellipsis: true, displayAfter: "lg" },
            { page: currentPage - 1, displayAfter: "sm" },
            { page: currentPage },
            { page: currentPage + 1, displayAfter: "sm" },
            { page: currentPage + 2, displayAfter: "lg" },
            { page: totalPage, displayAfter: "us" },
        ];
    }
    if (currentPage === totalPage - 2) {
        return [
            { page: 1, displayAfter: "us" },
            { page: 2, displayAfter: "lg" },
            { ellipsis: true, displayAfter: "lg" },
            { page: currentPage - 1, displayAfter: "sm" },
            { page: currentPage },
            { page: currentPage + 1, displayAfter: "sm" },
            { page: totalPage, displayAfter: "us" },
        ];
    }
    if (currentPage === totalPage - 1) {
        return [
            { page: 1, displayAfter: "us" },
            { page: 2, displayAfter: "sm" },
            { page: 3, displayAfter: "lg" },
            { ellipsis: true, displayAfter: "lg" },
            { page: currentPage - 1, displayAfter: "sm" },
            { page: currentPage },
            { page: totalPage, displayAfter: "us" },
        ];
    }
    if (currentPage === totalPage) {
        return [
            { page: 1, displayAfter: "us" },
            { page: 2, displayAfter: "sm" },
            { page: 3, displayAfter: "lg" },
            { ellipsis: true, displayAfter: "lg" },
            { page: currentPage - 2, displayAfter: "sm" },
            { page: currentPage - 1, displayAfter: "us" },
            { page: currentPage },
        ];
    }
    return [
        { page: 1, displayAfter: "us" },
        { ellipsis: true, displayAfter: "lg" },
        { page: currentPage - 1, displayAfter: "sm" },
        { page: currentPage },
        { page: currentPage + 1, displayAfter: "sm" },
        { ellipsis: true, displayAfter: "lg" },
        { page: totalPage, displayAfter: "us" },
    ];
};
